import { useState } from "react";
import { IoEyeOffOutline, IoEyeOutline } from "react-icons/io5";

const TextboxPassword = ({ id, name, register, errors, title, ...rest }) => {
  const [showPassword, setShowPassword] = useState(false);

  const renderIcon = () => {
    if (showPassword)
      return (
        <IoEyeOutline
          className="text-gray-300 text-xl cursor-pointer"
          onClick={() => setShowPassword(!showPassword)}
        />
      );

    return (
      <IoEyeOffOutline
        className="text-gray-300 text-xl cursor-pointer"
        onClick={() => setShowPassword(!showPassword)}
      />
    );
  };

  return (
    <>
      {title && (
        <label className="form-label" htmlFor={id}>
          {title}
        </label>
      )}
      <div className="relative">
        <input
          id={id}
          name={name}
          className={`form-control ${errors && errors[name] && "form-invalid"}`}
          type={showPassword ? "text" : "password"}
          {...rest}
          {...register}
        />
        <div className="absolute top-0 right-0 px-2 ml-2 mr-1 my-2 bg-white">
          {renderIcon()}
        </div>
      </div>
      {errors && errors[name] && (
        <div className="pt-2">
          <span className="text-sm text-red-400">{errors[name].message}</span>
        </div>
      )}
    </>
  );
};

export default TextboxPassword;
